import {API_DOMAIN} from '~/constants/env';

export function createAcceptHeaderValue(version: number): string {
  return `application/${API_DOMAIN}; version=${version}`;
}
